import React from "react";
import { MGTypography, TMGTypographyProps } from "../MGTypography/MGTypography";
import { MGTextStyleDefinitions, TMGTextStyleDefinitions } from "../../typography";

export type TMGTextProps = TMGTypographyProps & {
  textStyleDefinition: TMGTextStyleDefinitions;
};

export const MGText = ({ textStyleDefinition, ...props }: TMGTextProps) => (
  <MGTypography
    {...props}
    componentName="mg-text"
    definition={MGTextStyleDefinitions[textStyleDefinition]}
  />
);
